// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectsGridView__projectsGrid___jrPUA {
    width: 100%;
    max-width: 100%;
    margin-top: 2rem;
    font-size: 1.2rem;
}

.ProjectsGridView__table___I__jG {
    margin-bottom: 0.8rem;
}

.ProjectsGridView__pagination___keOQJ {
    padding-top: 2rem;
    padding-bottom: 2rem;
}

.ProjectsGridView__errorSize___Rou3B {
    color: var(--color-bg-alert);
}`, "",{"version":3,"sources":["webpack://./src/core/pages/Main/ProjectsView/ProjectsGridView/ProjectsGridView.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":[".projectsGrid {\n    width: 100%;\n    max-width: 100%;\n    margin-top: 2rem;\n    font-size: 1.2rem;\n}\n\n.table {\n    margin-bottom: 0.8rem;\n}\n\n.pagination {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n}\n\n.errorSize {\n    color: var(--color-bg-alert);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"projectsGrid": `ProjectsGridView__projectsGrid___jrPUA`,
	"table": `ProjectsGridView__table___I__jG`,
	"pagination": `ProjectsGridView__pagination___keOQJ`,
	"errorSize": `ProjectsGridView__errorSize___Rou3B`
};
export default ___CSS_LOADER_EXPORT___;
